import * as Zod from "zod";

export const tokensDecoder = Zod.object({
  id_token: Zod.string(),
  access_token: Zod.string(),
});

export type MarketplaceTokens = Zod.infer<typeof tokensDecoder>;

export const identityClaimsDecoder = Zod.object({
  organizationId: Zod.string(),
  userId: Zod.string().optional().nullable(),
  personId: Zod.string().optional().nullable(),
  domain: Zod.string(),
  userEmail: Zod.string(),
  name: Zod.string(),
  role: Zod.string().optional().nullable(),
  triggersAnalytics: Zod.boolean().optional().nullable(),
  isImpersonationSession: Zod.boolean().optional().nullable(),
  impersonationBy: Zod.string().optional().nullable(),
  trackingId: Zod.string().nullish(),
  profileImage: Zod.string().nullish(),
  partnerId: Zod.string().nullish(),
});

export type IdentityClaims = Zod.infer<typeof identityClaimsDecoder>;

export function hasOptedIntoPlatform(
  identity: IdentityClaims,
  platformOptedInCookie: string | null,
) {
  if (identity.role !== "marketplace_user") {
    return true;
  }

  if (platformOptedInCookie && platformOptedInCookie === identity.userId) {
    return true;
  }

  return false;
}
